module.exports = __webpack_public_path__ + "static/img/PK7.11a2282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK7.jpg
// module id = FItE
// module chunks = 0